import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { canUserManageShare } from '../../helpers/Share';
import { userIsAdmin, userIsManager } from '../../helpers/Auth';

const ModalTemplatesCustomGroupHeading = (props) => {
  const { children, handleClose, ...rest } = props;

  const intl = useIntl();

  const linkTo = children.toLowerCase() === 'workspace' ? '/admin/settings/share-settings' : '/profile/edit?tab=share-settings';

  return (
    <components.GroupHeading {...rest}>
      <div className="select-template-menu">
        <span>
          {children} {intl.formatMessage({ defaultMessage: 'TEMPLATES' })}
        </span>
        {canUserManageShare() && (children.toLowerCase() === 'user' || userIsAdmin() || userIsManager()) && (
          <Link to={linkTo} onClick={() => handleClose()}>
            <Button
              size="sm"
              color="link"
            >
              <i className="far fa-pencil" />{intl.formatMessage({ defaultMessage: 'Manage' })}
            </Button>
          </Link>
        )}
      </div>
    </components.GroupHeading>
  );
};

ModalTemplatesCustomGroupHeading.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ModalTemplatesCustomGroupHeading;
